import React, { useState } from "react";
import { MessageSquareWarning } from "lucide-react";
import { areaForTab } from "../../../lib/tickets";
import ReportDialog from "./ReportDialog";

/**
 * "Raportează", on top of every admin page (14.10.2026): opens the ticket
 * form already knowing the page it was pressed on.
 */
export default function ReportButton({ tab, onCreated }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)}
        className="text-sm rounded-full px-3 py-1.5 border border-[#965EA7]/40 text-[#7A4986] hover:bg-[#965EA7]/10 inline-flex items-center gap-1.5"
        data-testid="admin-report" title="Ceva nu merge sau ai o idee? Raportează de aici.">
        <MessageSquareWarning size={14} /> <span className="hidden sm:inline">Raportează</span>
      </button>
      <ReportDialog open={open} onClose={() => setOpen(false)} area={areaForTab(tab)} via="report_button" onCreated={onCreated} />
    </>
  );
}
